// src/apiBase.js
// Same-origin via the Hosting rewrite (/api/** -> api function). For local dev with
// the Firebase emulators this still works; if you point at the deployed function
// directly instead, set this to the full https URL of the `api` function.
export const API_BASE = "/api";
